<template>
  <card>
    <div slot="header">
      <h4 class="title">Account Profile</h4>
    </div>
    <div>
      <form>
        <div class="row">
          <div class="col-md-5">
            <fg-input type="text"
                      label="Company name"
                      required
                      :disabled="false"
                      placeholder="Company name"
                      v-model="companyName"
                      @keyup.enter="save()"
                      ref="tofocus">
           </fg-input>
          </div>
          <div class="col-md-7">
            <fg-input type="email"
                      label="Contact email"
                      required
                      placeholder="Email"
                      v-model="contactEmail"
                      @keyup.enter="save()">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Address line 1"
                      placeholder="Address line 1"
                      required
                      v-model="addressLine1"
                      @keyup.enter="save()">
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="Address line 2"
                      placeholder="Address line 2"
                      v-model="addressLine2"
                      @keyup.enter="save()">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input type="text"
                      label="Country"
                      placeholder="Country"
                      required
                      v-model="country"
                      @keyup.enter="save()">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input label="Province"
                      required>
              <el-select v-model="state" class="removeReadonly">
                <el-option
                  v-for="item in statesProvinces"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input type="text"
                      label="City"
                      required
                      placeholder="City"
                      v-model="city"
                      @keyup.enter="save()">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <fg-input label="Postal Code"
                      required
                      placeholder="Postal Code"
                      v-model="postalCode"
                      @keyup.enter="save()">
            </fg-input>
          </div>
          <div class="col-md-4">
            <fg-input label="Phone"
                      placeholder="Phone"
                      v-model="phone"
                      @keyup.enter="save()">
            </fg-input>
          </div>
          
          <div class="col-md-3">
            
            <fg-input label="Timezone"
                      required>
              <el-select v-model="timezoneOffset" class="removeReadonly">
                <el-option v-for="timezone in timezones"
                           :key="timezone.value"
                           :label="timezone.label"
                           :value="timezone.value"
                           @keyup.enter="save()"/>
              </el-select>
            </fg-input>
              
          </div>
        </div>

        <div class="row">
          <!-- <div class="col-md-3">
            <fg-input label="Fiscal year start">
              <el-select v-model="fiscalStartMonth" class="removeReadonly">
                <el-option v-for="month in months"
                           :key="month.value"
                           :label="month.label"
                           :value="month.value"/>
              </el-select>
            </fg-input>
            
          </div>

          <div class="col-md-1"/> -->
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input label="About your copmpany">
              <el-input type="textarea"
                        autosize
                        placeholder="This optional text will be visible to Affiliates you work with"
                        v-model="about"
                       @keyup.enter="save()">
              </el-input>
            </fg-input>
          </div>
        </div>
        <br>
        <div class="text-center">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="save">
            {{buttonLabel}}
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>

<script>
export default {
  name: 'Account-Profile',
  mounted () {
    setTimeout(() => this.$refs.tofocus.$el.children[1].focus(), 500)
    // this.$refs.tofocus.$el.children[0].focus()
  },
  data () {
    return {
      companyName:      this.$store.getters.accountProfile.companyName,
      contactEmail:     this.$store.getters.accountProfile.contactEmail,
      addressLine1:     this.$store.getters.accountProfile.address.addressLine1,
      addressLine2:     this.$store.getters.accountProfile.address.addressLine2,
      city:             this.$store.getters.accountProfile.address.city,
      country:          this.$store.getters.accountProfile.address.country,
      state:            this.$store.getters.accountProfile.address.state,
      postalCode:       this.$store.getters.accountProfile.address.postalCode,
      phone:            this.$store.getters.accountProfile.phone,
      about:            this.$store.getters.accountProfile.about,
      fiscalStartMonth: this.$store.getters.accountSetup.fiscalStartMonth,
      timezoneOffset:   this.$store.getters.accountSetup.timezoneOffset,
      statesProvinces: [
        { value: 'AB', label: 'AB' },
        { value: 'BC', label: 'BC' },
        { value: 'MB', label: 'MB' },
        { value: 'NB', label: 'NB' },
        { value: 'NL', label: 'NL' },
        { value: 'NU', label: 'NU' },
        { value: 'NS', label: 'NS' },
        { value: 'NT', label: 'NT' },
        { value: 'ON', label: 'ON' },
        { value: 'PE', label: 'PE' },
        { value: 'QC', label: 'QC' },
        { value: 'SK', label: 'SK' },
        { value: 'YT', label: 'YT' }
      ],
      months: [
        { value: 'january', label: 'January'},
        { value: 'february', label: 'February'},
        { value: 'march', label: 'March'},
        { value: 'april', label: 'April'},
        { value: 'may', label: 'May'},
        { value: 'june', label: 'June'},
        { value: 'july', label: 'July'},
        { value: 'august', label: 'August'},
        { value: 'september', label: 'September'},
        { value: 'october', label: 'October'},
        { value: 'november', label: 'November'},
        { value: 'december', label: 'December'},
      ],
      timezones: [
        { value: -4, label: 'Eastern Time' },
        { value: -5, label: 'Central Time' },
        { value: -6, label: 'Mountain Time' },
        { value: -7, label: 'Pacific Time' },
      ]
    }
  },
  methods: {
    async save () {
      const res1 = await this.$store.dispatch('saveAccountProfile', { companyName: this.companyName,
                                                 contactEmail: this.contactEmail,
                                                 address: {
                                                   addressLine1: this.addressLine1,
                                                   addressLine2: this.addressLine2,
                                                   city: this.city,
                                                   country: this.country,
                                                   state: this.state,
                                                   postalCode: this.postalCode,
                                                 },
                                                 phone: this.phone,
                                                 about: this.about})
      const res2 = await this.$store.dispatch('saveAccountSetup', { 
                                                 fiscalStartMonth: this.fiscalStartMonth,
                                                 timezoneOffset: Number(this.timezoneOffset)})
      if (res1.errors) {
        if (!res1.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res1.errors[0] })
        }
      }
      if (res2.errors) {
        if (!res2.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res2.errors[0] })
        }
      }
      if (!res1.errors && !res2.errors) {
        this.$notify({ successMessage: 'Saved!'})
        if (!this.$store.getters.isSpiffsLeadsSetupComplete) {
          this.$emit('changetab', 'Spiffs&Leads')
        }
      }
    },
  },
  computed: {
    buttonLabel () {
      return this.$store.getters.isSpiffsLeadsSetupComplete ? 'Save' : 'Save & Next'
    }
  }
}
</script>

<style>

</style>